var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"polls"},[(_vm.activePoll)?_c('poll-form',{on:{"submitAnswer":_vm.submitted}}):(_vm.sharedPollResults)?_c('poll-results'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }